import { IconSucessGreen } from 'assets/images/services';
import BordUploaderButton from 'components/NudosComponents/BordUploaderButton/BordUploaderButton';
import {
  ServiceSummaryVariantIconColor,
  SERVICE_SUMMARY_VARIANT_TEXT,
  SummaryVariant
} from 'components/SummaryBanner/SummaryBanner.types';
import { ACCEPTED_FILE_EXTENSION } from 'components/NudosComponents/BordUploaderButton/BordUploaderButton.types';
import './QuoteStatusInServiceSummary.scss';

interface IQuoteStatusInServiceSummaryProps {
  variant: SummaryVariant;
  icon?: JSX.Element;
  quoteLink?: string;
  isManualQuote?: boolean;
}

const QuoteStatusInServiceSummary = ({
  variant,
  quoteLink,
  isManualQuote,
  icon
}: IQuoteStatusInServiceSummaryProps) => {
  return (
    <div className="quoteStatusContainer">
      {isManualQuote && (
        <div className="quoteStatus">
          Estado de la cotización:{' '}
          <span className="quoteStatusText" style={{ color: ServiceSummaryVariantIconColor[variant] }}>
            {SERVICE_SUMMARY_VARIANT_TEXT[variant]}
            {icon || <IconSucessGreen />}
          </span>
        </div>
      )}
      <BordUploaderButton
        defaultFile={{
          documentName: (
            <span className="downloadButtonTitle">
              <span>Resumen del servicio.pdf</span>
            </span>
          ),
          url: quoteLink
        }}
        customClassName="uploaderButton"
        acceptFileExtension={[ACCEPTED_FILE_EXTENSION.PDF]}
        isFilled={!!quoteLink}
        handleDownloadFile={() => window.open(quoteLink, '_blank')}
      />
    </div>
  );
};

export default QuoteStatusInServiceSummary;
